import React from 'react';
import './TemplatePage.css';

function TemplateRightSidebar() {
  return (
    <div className="template-page">
      <div className="template-hero">
        <div className="container">
          <h1>Template Right Sidebar</h1>
          <p>Professional template with right sidebar layout</p>
        </div>
      </div>
      
      <div className="container">
        <div className="template-layout right-sidebar">
          <div className="template-content">
            <h2>Right Sidebar Template</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
            <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis.</p>
          </div>
          
          <div className="template-sidebar">
            <div className="sidebar-widget">
              <h3>Category</h3>
              <ul>
                <li><a href="#">Uncategorized</a></li>
                <li><a href="#">Sports</a></li>
                <li><a href="#">Fitness</a></li>
                <li><a href="#">Training</a></li>
              </ul>
            </div>
            
            <div className="sidebar-widget">
              <h3>Archives</h3>
              <ul>
                <li><a href="#">February 2024</a></li>
                <li><a href="#">January 2024</a></li>
                <li><a href="#">December 2023</a></li>
                <li><a href="#">November 2023</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer id="contact" className="footer">
        <div className="footer-background"></div>
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">About Us</h3>
              <p className="footer-text">
                We are committed to excellence in sports training and community building. 
                Our comprehensive programs help athletes develop both physically and mentally.
              </p>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Latest Posts</h3>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">15</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">New Training Program Launched</h4>
                  <p className="post-excerpt">Advanced coaching techniques for professional athletes</p>
                </div>
              </div>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">04</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">Championship Results Announced</h4>
                  <p className="post-excerpt">Outstanding performances in the latest tournament</p>
                </div>
              </div>
              <a href="#" className="view-more">View More...</a>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                <li><a href="#" className="footer-link active">HOME</a></li>
                <li><a href="#" className="footer-link">ABOUT OUR WEBSITE</a></li>
                <li><a href="#" className="footer-link">SHOP</a></li>
                <li><a href="#" className="footer-link">GALLERY</a></li>
                <li><a href="#" className="footer-link">CONTACT</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Contact Details</h3>
              <div className="contact-info">
                <div className="contact-item">📞 +91-98294 49492</div>
                <div className="contact-item">📞 +91-98870 49492</div>
                <div className="contact-item">✉️ rkaggarwaljpr@gmail.com</div>
                <div className="contact-item">📍 Regd. Office: B-7, Ganesh Nagar, New Sanganer Road, Sodala, Jaipur-302019 (Raj.) INDIA</div>
                <div className="contact-item">📍 Corp. Office: Plot No. 3/3 A, Surya Nagar, Gopalpura Byepass, Jaipur-302019 (Raj.) INDIA</div>
                <div className="contact-item">📍 Factory Address: 15 Dr. Rajender Prasad Nagar-B, Jaipur-302020 (Raj.) INDIA</div>
              </div>
            </div>
          </div>
          <div className="footer-logo">
            <img src="/assets/main logo.png" alt="Elite International Sports Logo" className="footer-logo-icon" />
            <span className="footer-logo-text">ELITE INTERNATIONAL SPORTS</span>
          </div>
          <div className="footer-social">
            <span className="social-icon">f</span>
            <span className="social-icon">t</span>
            <span className="social-icon">in</span>
            <span className="social-icon">G+</span>
          </div>
          <div className="footer-copyright">
            Copyright © 2023 Elite International Sports. Building Future, Shaping Champions.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default TemplateRightSidebar;
